import React from 'react';

import { TableCell } from 'components/dataTable';
import { DataTableCellProps } from 'components/dataTable/dataTable.types';

import { ApiKeyTableRow } from '../../types';

export const SecretKeyCell = ({ row }: DataTableCellProps) => {
  const { secretKeyTruncated } = row as ApiKeyTableRow;

  return <TableCell align="left">{secretKeyTruncated}</TableCell>;
};
